import { useEffect, useState } from 'react'
import { LabApiError, labApi, readToken } from './api'
import { canonicalLoginUrl, safeLabReturn } from './login-url'

/**
 * Login bridge for Lab. It re-checks localStorage at click/navigation time,
 * avoiding a redundant OAuth flow when an already-valid main-site session was
 * rendered as signed out by stale UI state.
 */
export function AuthContinuePage() {
  const [message, setMessage] = useState('Checking your SandBase session…')

  useEffect(() => {
    let cancelled = false
    const origin = window.location.origin
    const target = safeLabReturn(new URLSearchParams(window.location.search).get('redirect'), origin)
    const oauth = () => window.location.replace(canonicalLoginUrl(target, origin))

    const continueSession = async () => {
      if (!readToken()) { oauth(); return }
      try {
        // This endpoint validates the token through apiserver /default/v1/me.
        await labApi<{ items: unknown[] }>('/lab/api/run/pelican-test/mine?limit=1', { auth: true })
        if (!cancelled) window.location.replace(target)
      } catch (error) {
        if (cancelled) return
        if (error instanceof LabApiError && error.status === 401) {
          setMessage('Your previous session expired. Opening secure sign in…')
          oauth()
          return
        }
        // A transient Lab/D1 error is not evidence that the main-site token is
        // invalid. Return to Lab and let the requested page report its own error.
        window.location.replace(target)
      }
    }
    void continueSession()
    return () => { cancelled = true }
  }, [])

  return (
    <section className="auth-continue" aria-live="polite">
      <div className="auth-continue-card">
        <span className="auth-continue-mark" aria-hidden="true" />
        <p className="eyebrow">SandBase Lab</p>
        <h1>Continue to Lab</h1>
        <p className="muted">{message}</p>
      </div>
    </section>
  )
}
